<template>
  <el-dialog
    title="人员实时信息"
    :visible.sync="visible"
    width="520px"
    :show-close="true"
    class="user-dialog"
    top="6vh"
    append-to-body
    @close="handleClose"
  >
    <div v-if="formData.employeeId" class="dialog-content">
      <div class="user-basic">
        <div class="avatar">{{ avatarText }}</div>
        <div>
          <div class="user-name">{{ formData.employeeName || '未命名人员' }}</div>
          <div class="user-id">人员ID：{{ formData.employeeId }}</div>
          <div class="user-id">部门：{{ formData.deptName || '—' }}</div>
        </div>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">RTK设备</span>
          <span class="value">{{ formData.rtkId || formData.deviceId || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="label">设备状态</span>
          <span class="value" :class="formData.deviceOnline ? 'online' : 'offline'">
            {{ formData.deviceOnline ? '在线' : '离线' }}
          </span>
        </div>
        <div class="info-item">
          <span class="label">经度</span>
          <span class="value">{{ formData.longitude || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="label">纬度</span>
          <span class="value">{{ formData.latitude || '—' }}</span>
        </div>
        <div class="info-item full">
          <span class="label">最近上报</span>
          <span class="value">{{ formData.reportTime || '暂无定位' }}</span>
        </div>
        <div class="info-item full">
          <span class="label">当前工单</span>
          <span class="value">
            {{ formData.inInspection ? `${formData.currentWorkOrderCode || '—'} / ${formData.currentWorkOrderName || '—'}` : '空闲' }}
          </span>
        </div>
        <div class="info-item full">
          <span class="label">巡检路线</span>
          <span class="value">{{ formData.inspectionRouteName || '—' }}</span>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose" size="small">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserInfoDialog',
  data () {
    return {
      visible: false,
      formData: {}
    }
  },
  computed: {
    avatarText () {
      const name = this.formData.employeeName || '人'
      return name.slice(0, 1)
    }
  },
  methods: {
    open (userData) {
      this.formData = { ...userData }
      this.visible = true
    },
    handleClose () {
      this.visible = false
      this.formData = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.user-dialog {
  ::v-deep .el-dialog {
    max-height: calc(100vh - 72px);
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-dialog__header {
    flex-shrink: 0;
    padding: 18px 20px 12px;
  }

  ::v-deep .el-dialog__body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 14px 20px 16px;
  }

  ::v-deep .el-dialog__footer {
    flex-shrink: 0;
    padding: 10px 20px 16px;
    border-top: 1px solid #ebeef5;
  }
}

.dialog-content {
  padding-top: 4px;
}

.user-basic {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
}

.user-name {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 6px;
}

.user-id {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding-top: 16px;
}

.info-item {
  min-height: 48px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}

.info-item.full {
  grid-column: 1 / 3;
}

.label {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.value {
  font-size: 14px;
  color: #303133;
  word-break: break-all;
}

.value.online {
  color: #16a34a;
  font-weight: 600;
}

.value.offline {
  color: #909399;
  font-weight: 600;
}

@media (max-width: 640px) {
  .user-dialog {
    ::v-deep .el-dialog {
      width: calc(100vw - 24px) !important;
      max-height: calc(100vh - 48px);
    }
  }
}
</style>
